<template>
    <table v-if="!isLoading" class="tableStyle" aria-describedby="dividerTable">
      <td class="divider"><hr /></td>
      <td class="tdStyle">{{ closingText }}</td>
      <td class="divider"><hr /></td>
    </table>
</template>

<script>

export default {
    props: {
        conversationAttributes: {
            type: Object,
            default: () => { }
        }
    },
    computed: {
        isLoading() {
          return this.conversationAttributes?.loading ?? false;
        },
        closingText() {
            const agent = this.conversationAttributes?.performer?.name;
            if (!agent) {
                return 'Chat was closed';
            }
            return `${agent} closed this chat`;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '~widget/assets/scss/variables.scss';

.tableStyle {
    width: 100%;
}

.tdStyle {
    width:1px;
    padding: 0 10px;
    white-space: nowrap;
    line-height: 50px;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    font-size: 13px;
    color: #6C7B94;
    height: 50px;
}

.divider{
    color: $color-border;
    text-align: center;
    vertical-align: middle;
}
</style>
